import React from 'react';
import { Chef, Recipe } from './types';

interface ChefCardProps {
  chef: Chef;
  recipes: Recipe[];
  onClick: () => void;
}

export const ChefCard: React.FC<ChefCardProps> = ({ chef, recipes, onClick }) => (
  <div className="chef-card" onClick={onClick}>
    <img src={chef.image_url} alt={chef.name} />
    <h3>{chef.name}</h3>
    <p>{chef.establishment_name}</p>
    <span className="cuisine">{chef.cuisine}</span>
    <span className="establishment-type">{chef.establishment_type}</span>
    <p className="location">{chef.location.city}, {chef.location.state}, {chef.location.country}</p>
    <div className="recipe-preview">
      <h4>Specialties:</h4>
      <ul>
        {recipes.slice(0, 3).map(recipe => (
          <li key={recipe.recipe_id}>{recipe.name}</li>
        ))}
      </ul>
    </div>
  </div>
);